import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthStore from '@/modules/auth/store'
import store from '@/store'

import advancedAnalyticsRoutes from '@/modules/analytics/router'
import authRoutes from '@/modules/auth/router'
import bookRoutes from '@/modules/books/router'
import categoriesRoutes from '@/modules/categories/router'
import eventRoutes from '@/modules/events/router'
import feedRoutes from '@/modules/feed/router'
import groupRoutes from '@/modules/groups/router'
import listRoutes from '@/modules/lists/router'
import landingPagesRoutes from '@/modules/landing-pages/router'
import orderRoutes from '@/modules/orders/router'
import postRoutes from '@/modules/posts/router'
import { userFollowsRoutes, userRoutes } from '@/modules/users/router'
import searchRoutes from '@/modules/search/router'
import staticRoutes from '@/modules/statics/router'
import subscriptionRoutes from '@/modules/subscriptions/router'
import tagRoutes from '@/modules/tags/router'
import walletRoutes from '@/modules/wallets/router'

Vue.use(VueRouter)

const Home = () => {
  return AuthStore.state.authenticated
    ? import('@/modules/home/views/Home.vue')
    : import('@/modules/landing/views/Landing.vue')
}

const routes = [
  {
    path: '/',
    component: Home
  },
  ...advancedAnalyticsRoutes,
  ...authRoutes,
  ...searchRoutes,
  ...feedRoutes,
  ...listRoutes,
  ...categoriesRoutes,
  ...groupRoutes,
  ...bookRoutes,
  ...staticRoutes,
  ...landingPagesRoutes,
  ...eventRoutes,
  ...tagRoutes,
  ...orderRoutes,
  ...subscriptionRoutes,
  ...walletRoutes,
  ...userFollowsRoutes,
  ...postRoutes,
  ...userRoutes,
  { path: '', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  store.dispatch('clearErrors')
  if (to.matched.some(route => route.meta.requiresNotAuthenticated)) {
    if (AuthStore.state.authenticated) {
      return next({ path: '/' })
    }
  }
  if (to.matched.some(route => route.meta.requiresAuthentication)) {
    if (!AuthStore.state.authenticated) {
      return next({ path: '/' })
    }
  }
  next()
})

export default router
